import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    id = '',
    name = '',
    summary = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.myOrgDep.save, {
        id,
        name,
        summary,
    }, options);
    if (error) return { error, status };
    return content || {};
};
